<template>
  <div class="cookies container">
    <b-row>
      <b-col md="10" offset-md="1">
        <h2 class="custom-title mt-5">Use of cookies</h2>

        <HideableParagraph
          v-for="(block, idx) in cookiesInformation"
          :key="idx"
          :title="block.title"
          :text="block.text"
          :is-hideable="false"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { cookiesInformation } from './constant';
import HideableParagraph from '@/components/HideableParagraph';

export default {
  name: 'CookiesPage',

  components: {
    HideableParagraph
  },

  data() {
    return {
      cookiesInformation
    };
  },

  head: {
    title: 'Use of cookies | Found',
    meta: [
      {
        hid: 'description',
        name: 'description',
        content:
          'When you visit Found website, it may store or retrieve information on your browser, mostly in the form of cookie'
      }
    ]
  }
};
</script>
